/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
	getSubscriptionPlans,
	getSubscriptionPlan,
	printSubscriptionPlan,
	createSubscriptionPlans,
	updateSubscriptionPlans,
	deleteSubscriptionPlans,
} from "./api.subscription_plan";

const state = {
	page: {},
	form: {},
	subscription_plans: [],
	subscription_plan_options: [],
	selectedSubscriptionPlan: {
		plan_id: null,
		company_id: "",
		subscription_plan_date: "",
		reference_number: "",
		status_id: "",
		billing_address_id: "",
		shipping_address_id: "",
		comments: "",
		subscription_plan_details: [],
	},
	subscription_plans_filter: {
		search: "",
		page_size: 2,
		page_num: 1,
	},
	rules_subscription_plans: {
		plan_id: {
			name: "plan_id",
			rules: "trim|integer|required",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		plan_code: {
			name: "plan_code",
			rules: "trim|max_length[20]|is_unique[subscription_plans.plan_code]|required",
			max_len: "20",
			min_len: "",
			default_value: "",
		},
		plan_name: {
			name: "plan_name",
			rules: "trim|max_length[65]|required",
			max_len: "65",
			min_len: "",
			default_value: "",
		},
		description: {
			name: "description",
			rules: "trim",
			max_len: "65535",
			min_len: "",
			default_value: "",
		},
		amount: {
			name: "amount",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "0.00",
		},
		currency_code: {
			name: "currency_code",
			rules: "trim|max_length[3]|required",
			max_len: "3",
			min_len: "",
			default_value: "USD",
		},
		term_months: {
			name: "term_months",
			rules: "trim|integer|required",
			max_len: "",
			min_len: "",
			default_value: "12",
		},
		is_active: {
			name: "is_active",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "1",
		},
		zoho_item_id: {
			name: "zoho_item_id",
			rules: "trim|max_length[36]",
			max_len: "36",
			min_len: "",
			default_value: "",
		},
	},
};

// getters
const getters = {
	subscription_plans: (state) => {
		return state.subscription_plans;
	},
};

// actions
const actions = {
	async fetchSubscriptionPlans({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getSubscriptionPlans({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "page",
						with: response.data.page,
					});
				}

				if (body.options) {
					commit("mutate", {
						property: "subscription_plan_options",
						with: response.data.subscription_plans,
					});
				} else {
					commit("mutate", {
						property: "subscription_plans",
						with: response.data.subscription_plans,
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
	async fetchSubscriptionPlan({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await getSubscriptionPlan(payload.id);

			if (typeof response !== "undefined" && response.data) {
				commit("mutate", {
					property: "selectedSubscriptionPlan",
					with: response.data.subscription_plan,
				});
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async printSubscriptionPlan({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await printSubscriptionPlan(payload.id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch print response error");
				return;
			}
		} catch (error) {
			console.log("print error");
			return;
		}
	},
	async saveSubscriptionPlan({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			if (typeof body["plan_id"] === "undefined" || body["plan_id"] == null || body["plan_id"] == "") {
				delete body["plan_id"];
				response = await createSubscriptionPlans({ body: body, headers: config.headers });
			} else {
				let plan_id = body["plan_id"];
				delete body["plan_id"];
				response = await updateSubscriptionPlans({ body: body, headers: config.headers }, plan_id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log("save error");
			return;
		}
	},
	async deleteSubscriptionPlan({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await deleteSubscriptionPlans(payload.id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("delete response error");
				return;
			}
		} catch (error) {
			console.log("delete error");
			return;
		}
	},
};

// mutations
const mutations = {
	mutate(state, payload) {
		state[payload.property] = payload.with;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
